import React from 'react';
import { useSiteSettings } from '../hooks/useContent';
import { usePageSeo } from '../hooks/usePageSeo';
import './Store.css';

const Store = () => {
  const { settings } = useSiteSettings();
  const publicBase =
    String(settings?.site_public_url || '').replace(/\/$/, '') ||
    (typeof window !== 'undefined' ? window.location.origin : '');
  const brand = settings?.site_brand_name || 'Invincible NGO';

  usePageSeo({
    title: `Store | ${brand}`,
    description: 'Coming Soon!',
    canonical: publicBase ? `${publicBase}/store` : undefined
  });

  return (
    <div className="store-minimal-page">
      <h1 className="store-minimal-title">Coming Soon!</h1>
    </div>
  );
};

export default Store;
